module.exports = __webpack_public_path__ + "static/img/BI.6c75f1f3.png";